module.exports = __webpack_public_path__ + "static/media/gram1.2183bcd3.jpg";